export const planPayment = {
  billingAddress: {
    title: "Billing Address",
  },
  billingInterval: {
    heading: "Choose the best payment plan for you",
    subheading: "",
    "12-months": {
      description: "Billed every 12 months",
      pill: "",
      renewal: "Renews every 12 months. Cancel anytime.",
    },
    "6-months": {
      description: "Billed every 6 months",
      pill: "",
      renewal: "Renews every 6 months. Cancel anytime.",
    },
    "3-months": {
      description: "Billed every 3 months",
      pill: "Best value",
      renewal: "Renews every 3 months. Cancel anytime.",
    },
    "1-month": {
      description: "Billed monthly",
      pill: "",
      renewal: "Renews every month. Cancel anytime.",
    },
    termMonthShort: "mo",
    termMonthLong: "month",
    options: ["3-months", "1-month"],
  },
  extend: {
    discount: {
      label: "Extend + Save Promo",
      disclaimer:
        "This reflects the price for the next month of your subscription. After that, the price will be ${{amount}}/month.",
    },
    totalToday: {
      label: "",
      amount: "",
    },
    submit: "Submit",
    terms:
      "By clicking “Submit” you acknowledge and agree that you are over 18, that this subscription will automatically renew, and that you will be charged the subscription amount each subscription term to your active payment method until your subscription is canceled. You may cancel at any time on your account settings page, you must cancel your subscription before it renews to avoid the billing of the next subscription fee to our active payment method. All payments made prior to cancellation are non-refundable.",
    title: "Set up payment",
  },
  formSummary: "Summary",
  formTitle: "Payment Method",
  planInfo: {
    plus: {
      title: "$t(common.plans.plus)",
    },
    premium: {
      title: "$t(common.plans.premium)",
    },
    weight_loss: {
      title: "$t(common.plans.plus)",
    },
    formattedPrice: "<strong>${{price}}/mo</strong>",
  },
  promoCode: {
    add: "Have a promo code?",
    apply: "Apply",
    applyOrClear: "Apply or clear promotion code to continue.",
    coupon:
      "{{code}} Promo applies to the first {{durationInMonths}} month(s) only, additional months will be charged at ${{fullPrice}}/mo",
    formattedDiscount: "-${{discountAmount}}",
    referAFriend: "Refer-a-friend",
    placeholder: "Promo code",
  },
  payment: {
    submit: "Start your membership",
    terms:
      "By clicking “Subscribe” you acknowledge and agree that you are over 18, that you will be charged for your first term immediately, and that you will be charged the subscription amount each subscription term to your active payment method until your subscription is canceled. You may cancel at any time on your account settings page; you must cancel your subscription before it renews to avoid the billing of the next subscription fee to your active payment method. All payments made prior to cancellation are non-refundable.",
    title: "Join now, cancel any time",
    totalToday: {
      label: "Payment due today",
      amount: "${{price}}",
    },
    totalAfterTrial: {
      label: "Payment due starting {{date}}",
      amount: "${{price}}",
    },
  },
  price: {
    withTermShort: "${{price}}/mo",
    withTermLong: "${{price}}/month",
    withMonthlyCalculation:
      "<strong>${{price}}</strong> (${{monthlyPrice}}/mo)",
  },
  resubscribe: {
    totalToday: {
      label: "Today's total",
      amount: "${{price}}",
    },
    submit: "Subscribe",
    terms:
      "By clicking “Subscribe” you acknowledge and agree that you are over 18, that you will be charged for your first month immediately, and that you will be charged the subscription amount each subscription term to your active payment method until your subscription is canceled. You may cancel at any time on your account settings page; you must cancel your subscription before it renews to avoid the billing of the next subscription fee to your active payment method. All payments made prior to cancellation are non-refundable.",
    title: "Welcome back!",
  },
  subtotal: {
    label: "Subtotal",
    price: "<strong>${{price}}.00</strong>",
  },
  yourPlan: {
    heading: "Your Plan",
    changePlanLinkText: "Change plan",
  },
};
